<template>
  <v-container fluid class="mx-7 mt-6">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card
        inline
        icon="mdi-axis-arrow-lock"
        color="primary"        
        class="px-5 py-4 ml-0"
      >
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{title}}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-movimentacao-blindada"
                color="success"
                min-width="100"
                style="float: right"
                class="mt-5 mr-0"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>
  
<script>
import MovimentacaoBlindadaService from '@/services/MovimentacaoBlindadaService';
import dateFormatterMixins from '@/mixins/dateFormatterMixins';
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [dateFormatterMixins, tourMixins],

  components: {
    Parametros: () => import("@/components/movimentacaoBlindada/Parametros.vue")
  },

  created() {
    this.$store.dispatch('clearMovimentacaoBlindada');
  },
  
  mounted() {
    if (this.$route.params.id) this.getById(this.$route.params.id);
    this.iniciarTourPagina();
  },
  
  data: () => ({
    loading: false,
    arrTour: [
      {
        element: '#titulo-movimentacao-blindada',
        intro: 'Aqui você poderá inserir um nome para sua movimentação da base homologada.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#date-picker-data-corte-ultimo-ciclo',
        intro: 'Aqui você poderá inserir a data de corte do último ciclo.',
        scrollTo: "tooltip",
        position: 'left'
      },
      {
        element: '#select-versao-movimentacao-blindada',
        intro: 'Aqui você poderá selecionar a versão do laudo blindado correspondente à data de corte escolhida.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#date-picker-data-atualizacao',
        intro: 'Aqui você poderá inserir a data limite de atualização dos dados.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#arquivo-baixas-movimentacao-blindada',
        intro: 'Aqui você poderá inserir o arquivo de baixas dos ativos que serão baixados.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#arquivo-transferencias-movimentacao-blindada',
        intro: 'Aqui você poderá inserir o arquivo de transferências entre imobilizados.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#arquivo-ia-movimentacao-blindada',
        intro: 'Aqui você poderá inserir o arquivo opcional com os percentuais de IA.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#arquivo-elegibilidade-movimentacao-blindada',
        intro: 'Aqui você poderá inserir o arquivo opcional de elegibilidade.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#btn-save-movimentacao-blindada',
        intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua movimentação da base homologada.',
        scrollTo: "tooltip",
        position: 'left'
      },
    ]
  }),

  computed: {
    title() {
      return this.$route.params.id ? `Editando Movimentação da Base Homologada` : 'Adicionar Nova Movimentação da Base Homologada';
    }
  },
  
  methods: {
    getById(id) {
      MovimentacaoBlindadaService.getById(id).then(response => {
        this.setDataInVuex(response.data.data);
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar movimentação da base homologada.', '',{position:'topRight'});
      });
    },
  
    salvar() {
      const data = this.$refs.parametrosREF.exportData();
      this.loading = true;
    
      MovimentacaoBlindadaService.salvar(data).then(() => {
        this.$toast.success('Movimentação da base homologada salva com sucesso.', '',{position:'topRight'})
        this.$router.push({ name: 'Movimentacao de Blindada Historico' });
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao salvar movimentação da base homologada.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },
    
    setDataInVuex(item) {
      const buildArquivoFakeState = (arquivo, delimitador, involucro, escape) => ({
        'id': arquivo ? arquivo.id : '',
        'fileObj': arquivo ? new File([""], arquivo.arquivo, { type: "text/csv" }) : undefined,
        'delimitador': delimitador || ';',
        'involucro': involucro || '"',
        'escape': escape || '"',
        'fakeFile': !!arquivo,
        'headerValido': !!arquivo
      });

      this.$store.dispatch('setMovimentacaoBlindada', {
        'titulo': item.titulo,
        'anoMesCorteUltimoCiclo': item.ano_mes_corte_ultimo_ciclo ? this.formatDateToPicker(item.ano_mes_corte_ultimo_ciclo) : null,
        'versao': item.versao,
        'atualizarAte': this.formatDateToPicker(item.atualizar_ate),
        'arquivoBaixas': buildArquivoFakeState(item.arquivo_baixas, item.arquivo_baixas_delimitador, item.arquivo_baixas_involucro, item.arquivo_baixas_escape),
        'arquivoTransferencias': buildArquivoFakeState(item.arquivo_transferencias, item.arquivo_transferencias_delimitador, item.arquivo_transferencias_involucro, item.arquivo_transferencias_escape),
        'arquivoIa': buildArquivoFakeState(item.arquivo_ia, item.arquivo_ia_delimitador, item.arquivo_ia_involucro, item.arquivo_ia_escape),
        'arquivoElegibilidade': buildArquivoFakeState(item.arquivo_elegibilidade, item.arquivo_elegibilidade_delimitador, item.arquivo_elegibilidade_involucro, item.arquivo_elegibilidade_escape)
      });

      this.$forceUpdate();
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  }
}
</script>
